import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import * as loaderSpinner from 'Assets/Images/spooky-loader.svg'
import Modal from './Modal'

const styles = {
  container: {
    color: 'white',
    cursor: 'pointer',
    height: 32,
    lineHeight: '32px',
    boxSizing: 'border-box',
    '&>img': {
      height: 32,
      verticalAlign: 'middle',
    },
    '&>span': {
      paddingLeft: 5,
      paddingRight: 5,
      verticalAlign: 'middle',
      position: 'relative',
      bottom: -3,
    },
  },
  errorWarning: {
    color: '#EE4360',
    border: '1px solid #EE4360',
    borderRadius: '50%',
  },
}

class Sync extends Component {
  state = {
    modalOpen: false,
    notifyError: this.props.hasError,
  }

  componentWillUpdate = newProps => {
    if (newProps.hasError && this.props.hasError === false)
      this.setState({ notifyError: true })
  }

  openModal = () => this.setState({ modalOpen: true })

  closeModal = e => this.setState({ modalOpen: false, notifyError: false })

  render = () => {
    const {
      className,
      classes,
      syncing,
      syncRequests,
      errorMessage,
    } = this.props

    const { modalOpen, notifyError } = this.state
    return [
      <div
        onClick={this.openModal}
        className={classNames(classes.container, className)}
      >
        <span>{syncing ? 'Syncing' : 'Synced'}</span>
        {syncing ? <img src={loaderSpinner} alt="loading" /> : null}
        {!syncing && notifyError ? (
          <span className={classes.errorWarning}>i</span>
        ) : null}
      </div>,
      // The event bubbles up through the portal and into the div click
      // handler triggering the openModal function, seems like a really odd
      // feature for React to have. So we're putting it outside the div
      modalOpen
        ? ReactDOM.createPortal(
            <Modal
              onClose={this.closeModal}
              syncRequests={syncRequests}
              errorMessage={errorMessage}
            />,
            document.getElementById('root2') || document.body,
          )
        : null,
    ]
  }
}

export default injectStyles(styles)(Sync)



// WEBPACK FOOTER //
// ./src/Components/Sync/index.js